import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m.574.346.414 7.607 1.553-.152-.311 2.814-1.035-.278-1.061 6.541 16.561 1.724-.466-4.31-8.202-2.206 5.77-.304-.388-3.728-5.357-.837 8.462-.811.699-4.336z"
    }, null, -1)
  ])))
}
export default { render: render }